module.exports = __webpack_public_path__ + "de77a722/img/file-icon.c085e21e.svg";